import './index.css'
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {NavLink, useLocation} from 'react-router-dom'
import { ReactComponent as AppsLine } from '@/assets/icons/apps-line.svg';
import { ReactComponent as JayapranaLogo } from '@/assets/icons/jayaprana-logo.svg'
import { ReactComponent as ExchangeFundsLine } from "@/assets/icons/exchange-funds-line.svg";
import { ReactComponent as CalendarCheckLine } from "@/assets/icons/calendar-check-line.svg";
import { ReactComponent as BillLine } from "@/assets/icons/bill-line.svg";
import { ReactComponent as RefundLine } from "@/assets/icons/refund-line.svg";
import { ReactComponent as ArticleLine } from "@/assets/icons/article-line.svg";
import { ReactComponent as CalendarEventLine } from "@/assets/icons/calendar-event-line.svg";
import { ReactComponent as MapPinLine } from "@/assets/icons/map-pin-line.svg";
import { ReactComponent as CouponLine } from "@/assets/icons/coupon-line.svg";
import { ReactComponent as CalendarLine } from "@/assets/icons/calendar-line.svg";
import { ReactComponent as FolderChartLine } from "@/assets/icons/folder-chart-line.svg";
import { ReactComponent as UserHeartLine } from "@/assets/icons/user-heart-line.svg";
import { ReactComponent as UserAdminLine } from "@/assets/icons/user-admin-line.svg";
import { ReactComponent as ArrowRightSLine } from "@/assets/icons/arrow-right-s-line.svg";
import { ReactComponent as CheckboxBlankCircleLine } from "@/assets/icons/checkbox-blank-circle-line.svg";
import { ReactComponent as IcImage } from "@/assets/icons/ic_image.svg";
import UserInfo from "@/components/common/UserInfo";
import { useAppDispatch, RootState } from '@/store';
import { getNotificationItem } from '@/store/notifications/action';
import { currentUser } from '@/store/current-user/action';

const sideBarItemsTop: Array<SideBarItem> = [
  {
    key: 'Dashboard',
    title: 'Dashboard',
    checkPath: '/dashboard/home',
    link: '/dashboard/home',
    logo: <AppsLine />,
  },
  {
    key: 'Subscription',
    title: 'Subscription',
    checkPath: '/dashboard/subscription',
    link: '/dashboard/subscriptions',
    logo: <ExchangeFundsLine />
  },
  {
    key: 'Booking',
    title: 'Booking',
    checkPath: '/dashboard/booking',
    link: '/dashboard/booking',
    logo: <CalendarCheckLine />
  },
  {
    key: 'Invoices',
    title: 'Invoices',
    checkPath: '/dashboard/invoice',
    link: '/dashboard/invoices',
    logo: <BillLine />
  },
  {
    key: 'Refund',
    title: 'Refund',
    checkPath: '/dashboard/refund',
    link: '/dashboard/refund',
    logo: <RefundLine />
  }
]

const sideBarItemsMiddle: Array<SideBarItem> = [
  {
    key: 'Gallery',
    title: 'Gallery',
    checkPath: '/dashboard/gallery',
    link: '/dashboard/gallery/banners',
    logo: <IcImage />,
    children: [
      {
        title: 'Banners',
        path: '/dashboard/gallery/banners',
      },
      {
        title: 'Photos',
        path: '/dashboard/gallery/photos'
      }
    ]

  },
  {
    key: 'News',
    title: 'News',
    checkPath: '/dashboard/news',
    link: '/dashboard/news',
    logo: <ArticleLine />
  },
  {
    key: 'Program',
    title: 'Program',
    checkPath: '/dashboard/programs',
    link: '/dashboard/programs',
    logo: <CalendarEventLine />
  },
  {
    key: 'Venue',
    title: 'Venue',
    checkPath: '/dashboard/venue',
    link: '/dashboard/venue',
    logo: <MapPinLine />
  },
  {
    key: 'Coupon',
    title: 'Coupon',
    checkPath: '/dashboard/coupon',
    link: '/dashboard/coupon',
    logo: <CouponLine />
  },
  {
    key: 'Operational Calendar',
    title: 'Operational Calendar',
    checkPath: '/dashboard/calendar',
    link: '/dashboard/calendar/closed-schedule',
    logo: <CalendarLine />,
    children: [
      {
        title: 'Closed Schedule',
        path: '/dashboard/calendar/closed-schedule',
      },
      {
        title: 'Holiday',
        path: '/dashboard/calendar/holiday'
      }
    ]

  }
]

const sideBarItemsBottom: Array<SideBarItem> = [
  {
    key: 'Report',
    title: 'Reports',
    checkPath: '/dashboard/report',
    link: '/dashboard/report/income',
    logo: <FolderChartLine />,
    children: [
      {
        title: 'Income Statement',
        path: '/dashboard/report/income'
      },
      {
        title: 'Booking Insight',
        path: '/dashboard/report/booking'
      }
    ]
  },
  {
    key: 'Customer',
    title: 'Customers',
    checkPath: '/dashboard/customer',
    link: '/dashboard/customer/list',
    logo: <UserHeartLine />,
    children: [
      {
        title: 'List Customers',
        path: '/dashboard/customer/list'
      },
      {
        title: 'Clubs',
        path: '/dashboard/customer/clubs'
      }
    ]
  },
  {
    key: 'User',
    title: 'User Management',
    checkPath: '/dashboard/admin',
    link: '/dashboard/admin/user',
    logo: <UserAdminLine />,
    children: [
      {
        title: 'User Management',
        path: '/dashboard/admin/user'
      },
      {
        title: 'Role Setting',
        path: '/dashboard/admin/role'
      }
    ]
  }
]

const match = (currentPath: string, checkPath: string) => currentPath.includes(checkPath);

const getItemChildren = (location: string, children: Array<SideBarChildren>) => (
  children.map(child =>
    <NavLink
      key={child.path}
      to={child.path}
      className={match(location, child.path) ? 'sidebar-children-active' : 'sidebar-children'}>
      <CheckboxBlankCircleLine />
      <span className="text-jsm">{child.title}</span>
    </NavLink>)
)

const getSideBarItems = (location: string, menus: Array<SideBarItem>) => menus.map(item =>
    window.localStorage.getItem('menu_list')?.includes(item.key) && (<div key={item.link}>
      <NavLink
        to={item.link}
        className={match(location, item.checkPath) ? 'sidebar-item-active' : 'sidebar-item'}>
        {item.logo}
        <span className='text-jsm'>{item.title}</span>
        {item.children && <div className='ml-auto'>
					<ArrowRightSLine />
				</div>}
      </NavLink>
      {item.children && match(location, item.checkPath) && getItemChildren(location, item.children)}
    </div>)
  )

const SideBar = () => {
  const { pathname } = useLocation();
  const [unreadNotification, setUnreadNotification] = useState(false)
  const notificationItem = useSelector((state: RootState) => state.notification.state?.items)
  const currentUserState = useSelector((state: RootState) => state.currentUser.state)
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(currentUser())
  }, [])
  useEffect(() => {
    (async () => {
      await dispatch(getNotificationItem(`${Date.now()}`))
    })()
  }, [pathname])
  useEffect(() => {
    setUnreadNotification(notificationItem.some(notif => notif.is_read === false))
  }, [notificationItem])

  return <div className="sidebar print-none">
    <div className="sidebar-company">
      <JayapranaLogo />
    </div>
    {getSideBarItems(pathname, sideBarItemsTop)}
    <div className="sidebar-separator"/>
    {getSideBarItems(pathname, sideBarItemsMiddle)}
    <div className="sidebar-separator"/>
    {getSideBarItems(pathname, sideBarItemsBottom)}
    <div className="mt-auto">
      <UserInfo unreadNotification={unreadNotification} notificationItem={notificationItem} currentUser={currentUserState}/>
    </div>
  </div>
};

export default SideBar;
